import { getApplicantByOnlineUserId } from '@/api/common/applicant';
import type { GetRebootApplicantResponseDto } from '@/api/reboot/applicant/applicant.dto';

export async function getRebootApplicant(
  onlineUserId: string,
  roundId?: string,
): Promise<GetRebootApplicantResponseDto> {
  return await getApplicantByOnlineUserId<GetRebootApplicantResponseDto>(
    onlineUserId,
    '취업 리부트 코스',
    roundId,
  );
}
